import React from 'react'
import { observer } from 'mobx-react'
import { rightSidebarStore as globalRightSidebarStore } from 'stores/UIStore'
import { formatCompactNumber } from '../../../utils'

const OverviewSection = observer(({
  safeAreaIncomeValue,
  highestPopulation,
  safeTotalPopulation,
  singlePolygonData,
  rightSidebarStore = globalRightSidebarStore,
  onOpenPopulationDashboard
}) => {
  const handlePopulationClick = () => {
    if (onOpenPopulationDashboard) {
      onOpenPopulationDashboard()
    }
  }

  // Prefer safeTotalPopulation (from People tab) for population consistency across tabs
  const displayPopulation = (safeTotalPopulation != null && safeTotalPopulation > 0)
    ? safeTotalPopulation
    : (highestPopulation !== undefined ? highestPopulation : 0)

  // Calculate Median HH Income:
  // For Target Groups: divide income value in HH income graph by number of shapes, boundaries, zip codes (don't divide by markers)
  const displayIncome = (() => {
    const store = rightSidebarStore || globalRightSidebarStore
    if (store && store.medianHouseholdIncome !== undefined) {
      return store.medianHouseholdIncome
    }
    const targetGroupId = store?.targetGroupId

    // Apply only for Target Groups
    if (targetGroupId && !singlePolygonData) {
      const regionCount = store?.getTargetGroupRegionsCount ? store.getTargetGroupRegionsCount(targetGroupId) : 0
      const chartData = store?.incomeAndPopDataForChart || []
      const graphIncome = (chartData.length > 0 && chartData[0]?.income != null)
        ? chartData[0].income
        : (safeAreaIncomeValue || 0)

      if (regionCount > 0) {
        return Math.round(graphIncome / regionCount)
      }

      return graphIncome || 0
    }

    // Default for single polygons and non-target groups
    return safeAreaIncomeValue || 0
  })()

  return (
    <div className='income-data-sidebar__section'>
      <div className='income-data-sidebar__section-header'>
        <h3 className='income-data-sidebar__section-title'>Overview</h3>
      </div>
      <div className='income-data-sidebar__overview-grid'>
        <div className='income-data-sidebar__overview-item'>
          <div className='income-data-sidebar__overview-value'>
            {displayIncome
              ? formatCompactNumber(displayIncome, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                compactMinimumFractionDigits: 0,
                compactMaximumFractionDigits: 1
              })
              : 0}
          </div>
          <div className='income-data-sidebar__overview-label'>Median HH income</div>
        </div>
        <div className='income-data-sidebar__overview-item'>
          <button
            type='button'
            className='income-data-sidebar__overview-button'
            onClick={handlePopulationClick}
            aria-label='Open Population Dashboard'
          >
            <div className='income-data-sidebar__overview-value'>
              {formatCompactNumber(displayPopulation)}
            </div>
            <div className='income-data-sidebar__overview-label'>Population</div>
          </button>
        </div>
      </div>
    </div>
  )
})

export default OverviewSection
